/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { websiteState } from "./website.state";
import { Logger } from "cms/utils/log/logger";

const website = createSlice({
    name: "website",

    initialState: websiteState,

    reducers: {
        setWebsiteItem (state, action) {
            const website = action.payload;
            const guid = website.guid;
            // Logger.debug(`%ccalling setWebsiteItem`, 'color: #ff45b5',website)
            state.byGUID[guid] = website;
        },
        setCurrentWebsite (state, action) {
            const website = action.payload;
            const guid = website.guid;
            // Logger.debug(`%ccalling setWebsiteItem`, 'color: #ff45b5',website)
            state.current_guid = guid;
            state.current = website;
        },

        setWebsiteNavigationTree (state, action) {
            const website_tree = action.payload;
            // Logger.debug(`%ccalling setWebsiteNavigationTree`, 'color: #ff45b5')
            state.navigation_tree = website_tree;
        },

        setSelectedNode (state, action) {
            const nav = action.payload;
            // Logger.debug(`%ccalling setSelectedNode`, 'color: #ff45b5',nav)
            // Logger.debug(`calling setSelectedNode `, nav)
            state.selectedNode = nav;
        },

        setSelectedNodeId (state, action) {
            const id = action.payload;
            // Logger.debug(`%ccalling setSelectedNodeId`, 'color: #ff45b5',id)
            state.selectedNodeId = id;
        },

        setWebsiteList (state, action) {
            const websites = action.payload;
            Logger.debug("ccalling setWebsiteIList", websites);
            state.list = websites;
        },
    },
});

export const websiteReducer = website.reducer;

export const {
    setWebsiteItem,
    setCurrentWebsite,
    setWebsiteHome,
    setWebsiteNavigationTree,
    setSelectedNode,
    setSelectedNodeId,
    setWebsiteList,
} = website.actions;
